import { DeliveryTimeType as AppDeliveryTimeType } from '@/features/orders/constants/app'
import { DeliveryTimeType as FirebaseDeliveryTimeType } from '@/features/orders/constants/firebase'
import invert from 'lodash.invert'

export const firebaseToAppDeliveryTimeType: Record<FirebaseDeliveryTimeType, AppDeliveryTimeType> =
    {
        [FirebaseDeliveryTimeType.Exact]: AppDeliveryTimeType.Exact,
        [FirebaseDeliveryTimeType.Asap]: AppDeliveryTimeType.Asap,
        [FirebaseDeliveryTimeType.Window]: AppDeliveryTimeType.Window,
    }

export const appToFirebaseDeliveryTimeType = invert(firebaseToAppDeliveryTimeType) as Record<
    AppDeliveryTimeType,
    FirebaseDeliveryTimeType
>
